import type { GetStaticProps, NextPage } from "next";
import { Missing404 } from "@/src/component/view/Missing404";
import { StringHelper } from "@/src/util";

interface Props {
  locale: string;
}

const Page404: NextPage<Props> = ({}) => {
  return <Missing404 />;
};

export const getStaticProps: GetStaticProps = async (context) => {
  const locale: string = StringHelper.checkIsStringOrIsNull(context?.params?.locale, "en");
  return {
    props: {
      locale,
      layout: "split",
    },
  };
};

export default Page404;
